/**
 * @license
 * Copyright 2026 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  dataSourceAutoDetectRegistry,
  registerKvStoreBasedDataProvider,
  registerProvider,
} from "#src/datasource/default_provider.js";
import { KvStoreBasedDataSourceLegacyUrlAdapter } from "#src/datasource/index.js";
import {
  ZarrVectorsDataSource,
  ZarrVectorsPointCloudDataSource,
  registerAutoDetect,
} from "#src/datasource/zarr-vectors/frontend.js";

const provider = new ZarrVectorsDataSource();
registerKvStoreBasedDataProvider(provider);
registerProvider(new KvStoreBasedDataSourceLegacyUrlAdapter(provider));

// Companion alias: re-interpret any zarr-vectors store as a point
// cloud, ignoring edges / manifests / cross-chunk links.  Same kvstore
// URL form as the main scheme but with `zarr-vectors-pointcloud:`.
const pointCloudProvider = new ZarrVectorsPointCloudDataSource();
registerKvStoreBasedDataProvider(pointCloudProvider);
registerProvider(
  new KvStoreBasedDataSourceLegacyUrlAdapter(pointCloudProvider),
);

registerAutoDetect(dataSourceAutoDetectRegistry);
